<template>
  <div class="pilot-achievement" :class="{ showPopup: isShow }">
    <div class="achievement-top">
      <span class="achievement-title">学习成就</span>
      <div class="hanlder-box">
        <span>{{ myAchievementCount + '/' + achievementList.length }}</span>
        <a-tooltip>
          <template #title>关闭</template>
          <svg class="icon-svg icon-close" @click="close()">
            <use xlink:href="#icon-close" />
          </svg>
        </a-tooltip>
      </div>
    </div>
    <div class="achievement-list">
      <div class="achievement-item" v-for="item of achievementList" @click="showAchievement = item">
        <i class="achievement-cover" :class="{ notshow: !item.hadGot }"
          :style="{ backgroundImage: 'url(' + item.cover + ')' }"></i>
      </div>
    </div>
  </div>
  <showAchievement :showAchievement="showAchievement" type="show" @closeBox="showAchievement = null"
    v-if="showAchievement"></showAchievement>
</template>

<script>
import { LoadingOutlined } from '@ant-design/icons-vue';
import showAchievement from "@/components/achievement/show-achievement/show-achievement.vue";

export default {
  components: {
    LoadingOutlined, showAchievement
  },
  name: "pilot-achievement",
  props: {
    phoneMode: Boolean
  },
  data() {
    return {
      theme_color: '',
      classGuid: '',
      myAchievementCount: 0,

      isShow: false,
      showAchievement: null,
      achievementList: [],
    }
  },
  async mounted() {
    this.$store.subscribe((res) => {
      if (!res) return;
      let { type, payload } = res;

      if (type == "pilotNavOpen") this.isShow = payload === 'achievement';
    })

    this.getAllAchievement();
  },
  methods: {
    //获取所有成就
    async getAllAchievement() {
      //找到已获得徽章
      let { levelInfo, allAchievementList = [] } = this.$store.state;
      let achievement = levelInfo ? levelInfo.achievement || [] : [];
      allAchievementList.forEach(aitem => {
        let amt = achievement.find(item => aitem._id == item.id);
        aitem.hadGot = amt ? true : false;
      })
      let ac1 = allAchievementList.filter(item => item.hadGot);
      let ac2 = allAchievementList.filter(item => !item.hadGot);
      this.achievementList = [...ac1, ...ac2];
      this.myAchievementCount = ac1.length;

      setTimeout(() => {
        $('.achievement-item').height($('.achievement-item').width())
      }, 100);
    },
    //关闭弹窗
    close() {
      this.$store.commit('pilotNavOpen', false);
    }
  },
}
</script>

<style scoped lang="scss">
@import "./pilot-achievement.scss";
</style>